import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 mt-auto">
      <div className="container mx-auto text-center">
        <p>
          &copy; {new Date().getFullYear()} Done Deal - Real Estate Client
          Scoring
        </p>
        <p className="text-sm mt-2">Powered by AI Technology</p>
      </div>
    </footer>
  );
};

export default Footer;
